export interface AppConfig {
    SHOW_SHORT_LINK: boolean;
    WHATSAPP_PHONE_NUMBER: string;
    WHATSAPP_ADD_LINK_PHONE: string;
    WHATSAPP_PHONE_NUMBER_BOX: string;
    PUBLIC_INDEX_JOIN_WHATSAPP_PHONE: string;
}

let config: AppConfig | null = null;

export async function getConfig(): Promise<AppConfig> {
    if (!config) {
        try {
            const response = await fetch('/_/config');
            config = await response.json();
        } catch {
            console.warn('Failed to fetch runtime config, using build-time fallback');
            config = {
                SHOW_SHORT_LINK: import.meta.env.VITE_SHOW_SHORT_LINK,
                WHATSAPP_PHONE_NUMBER: import.meta.env.VITE_WHATSAPP_PHONE_NUMBER,
                WHATSAPP_ADD_LINK_PHONE: import.meta.env.VITE_WHATSAPP_ADD_LINK_PHONE,
                WHATSAPP_PHONE_NUMBER_BOX: import.meta.env.VITE_WHATSAPP_PHONE_NUMBER_BOX,
                PUBLIC_INDEX_JOIN_WHATSAPP_PHONE: import.meta.env.VITE_PUBLIC_INDEX_JOIN_WHATSAPP_PHONE
            };
        }
    }
    return config!;
}